import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NvIconModule } from '../nv-icon/nv-icon.module';
import { NvPillModule } from '../nv-pill/nv-pill.module';
import { NvPillButtonComponent } from './nv-pill-button.component';

@NgModule({
  imports: [CommonModule, NvPillModule, NvIconModule],
  declarations: [NvPillButtonComponent],
  exports: [NvPillButtonComponent],
})
export class NvPillButtonModule {}
